<template>
    <div 
      v-if="visible" 
      class="privacy-modal-overlay"
      @click.self="close"
    >
      <div class="privacy-modal">
        <div class="privacy-modal__header">
          <h2 class="privacy-modal__title">{{ title }}</h2>
          <button class="privacy-modal__close" @click="close" aria-label="Uždaryti">
            ×
          </button>
        </div>
        <div class="privacy-modal__body">
          <slot></slot>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'PrivacyModal',
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      title: {
        type: String,
        default: 'Privatumo politika'
      }
    },
    emits: ['close'],
    methods: {
      close() {
        this.$emit('close')
      }
    },
    watch: {
      visible(newVal) {
        if (newVal) {
          document.body.style.overflow = 'hidden'
        } else {
          document.body.style.overflow = ''
        }
      }
    },
    beforeUnmount() {
      document.body.style.overflow = ''
    }
  }
  </script>
  
  <style scoped>
  .privacy-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: 10000;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    overflow-y: auto;
  }
  
  .privacy-modal {
    background: #fff;
    border-radius: 12px;
    max-width: 800px;
    width: 100%;
    max-height: 90vh;
    display: flex;
    flex-direction: column;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  }
  
  .privacy-modal__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 24px 28px;
    border-bottom: 1px solid #e5e5e5;
  }
  
  .privacy-modal__title {
    margin: 0;
    font-size: 1.5rem;
    font-weight: 700;
  }
  
  .privacy-modal__close {
    background: none;
    border: none;
    font-size: 32px;
    line-height: 1;
    color: #666;
    cursor: pointer;
    padding: 0;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: color 0.2s;
  }
  
  .privacy-modal__close:hover {
    color: #000;
  }
  
  .privacy-modal__body {
    padding: 28px;
    overflow-y: auto;
    flex: 1;
  }
  
  @media (max-width: 768px) {
    .privacy-modal {
      max-height: 95vh;
      border-radius: 12px 12px 0 0;
      margin-top: auto;
    }
    
    .privacy-modal__header,
    .privacy-modal__body {
      padding: 20px;
    }
  }
  </style>